import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

const SPINCreator = () => {
  const { t } = useTranslation();
  
  return (
    <div>
    <Typography variant="h4" gutterBottom>{t('spin')}</Typography>
    </div>
  );
};

export default SPINCreator;